import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.itineraries')
  .factory('$itineraries', itinerariesObjectFactory);

/* @ngInject */
function itinerariesObjectFactory($bringozFactory: $bringozFactory,
                                  ItinerariesAPI: BringozApi,
                                  Itineraries_DS: DataStoreConfig,
                                  Itineraries_PN: PushNotificationsConfig) {

  function $itineraries(id: string) {
    return $bringozFactory(id, ItinerariesAPI, Itineraries_DS, Itineraries_PN);
  }

  return $itineraries;
}
